export function useSchemaDownloadText(
  isDownloadable: MaybeRefOrGetter<boolean>,
  isCurated?: MaybeRefOrGetter<boolean>
) {
  const { loggedIn } = storeToRefs(useUserStore());
  const { t } = useI18n();
  const schemaDownloadText = computed(() => {
    const loginToDownloadText = t(
      "legal_text.middleColumn.schema_editor.not_logged_in_tooltip"
    );
    const cannotDownloadCuratedText = t(
      "legal_text.middleColumn.schema_editor.can_not_download_curated_text"
    );

    if (!loggedIn.value) {
      return toValue(isCurated)
        ? cannotDownloadCuratedText
        : loginToDownloadText;
    }

    return toValue(isDownloadable) ? "Download" : cannotDownloadCuratedText;
  });

  return schemaDownloadText;
}
